module.exports = __webpack_public_path__ + "static/media/pets-rush.2a84901d.jpg";